import { detectPlatform } from './detectPlatform';
import { selectByPlatform } from './select';
import type { PlatformOS, PlatformSelectSpec } from './types';

/**
 * Cross-platform Platform — drop-in replacement for react-native's Platform
 * with a richer `select` that supports device/form-factor/OS keys.
 *
 * Snapshot-based (not reactive). For reactivity, use `usePlatformValue` or
 * `<PlatformGate>` which re-evaluate on orientation/viewport changes.
 *
 * The shared module uses `detectPlatform()` so the values stay accurate after
 * hot reload. Use `Platform.select(...)` for module-scope decisions
 * (e.g. picking a constant or non-reactive component).
 */
function select<T>(spec: PlatformSelectSpec<T>): T | undefined {
  return selectByPlatform(spec, detectPlatform());
}

const info = detectPlatform();

export const Platform = {
  OS: info.os as PlatformOS,
  isPad: info.isPad,
  isTablet: info.isTablet,
  isPhone: info.isPhone,
  isDesktop: info.isDesktop,
  isTouch: info.isTouch,
  isNative: info.isNative,
  select,
};
